import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { history } from 'legacy/lut/helpers/route'
import { useCallback, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button, IButtonProps } from 'core-components/library/button'
import { getQbrPageLink } from 'partner360/components/QBR/helpers/getQbrPageLink'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

interface ICreateNewQbr {
  className?: string
  rtm: Nullable<PartnerType>
  predefinedPid?: string
  onClick?: () => void
  isOpenInNewTab?: boolean
  variant?: IButtonProps['variant']
}

export const CreateNewQbr = ({
  className,
  rtm,
  onClick,
  predefinedPid,
  isOpenInNewTab,
  variant,
}: ICreateNewQbr) => {
  const url = useMemo(() => {
    return getQbrPageLink(rtm, predefinedPid)
  }, [rtm, predefinedPid])

  const onCreate = useCallback(() => {
    history.push(url)
    if (onClick) {
      onClick()
    }
  }, [onClick, url])

  if (!rtm) {
    return null
  }

  if (isOpenInNewTab) {
    return (
      <Button href={url} target={'_blank'} className={className} variant={variant}>
        <Translation text={TRANSLATION_KEYS.buttons.createRecordButton} />
      </Button>
    )
  }

  return (
    <Button className={className} onClick={onCreate} variant={variant}>
      <Translation text={TRANSLATION_KEYS.buttons.createRecordButton} />
    </Button>
  )
}
